/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { labels_AssignLabelRequest } from '../models/labels_AssignLabelRequest';
import type { labels_BulkEntityLabelsResponse } from '../models/labels_BulkEntityLabelsResponse';
import type { labels_CreateLabelDefinitionRequest } from '../models/labels_CreateLabelDefinitionRequest';
import type { labels_LabelDefinitionResponse } from '../models/labels_LabelDefinitionResponse';
import type { labels_ReplaceLabelsRequest } from '../models/labels_ReplaceLabelsRequest';
import type { labels_UpdateLabelDefinitionRequest } from '../models/labels_UpdateLabelDefinitionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LabelsService {
    /**
     * Get labels for an entity
     * Get all labels assigned to a specific entity
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Entity ID
     * @returns labels_LabelDefinitionResponse OK
     * @throws ApiError
     */
    public static getApiV1Labels(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
    ): CancelablePromise<Array<labels_LabelDefinitionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/{entityType}/{id}/labels',
            path: {
                'entityType': entityType,
                'id': id,
            },
            errors: {
                400: `Invalid or missing parameters`,
                500: `Failed to get entity labels`,
            },
        });
    }
    /**
     * Assign a label to an entity
     * Assign a label to a specific entity
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Entity ID
     * @param body Label Assignment
     * @returns void
     * @throws ApiError
     */
    public static postApiV1Labels(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
        body: labels_AssignLabelRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/{entityType}/{id}/labels',
            path: {
                'entityType': entityType,
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid request or missing/invalid parameters`,
                500: `Failed to assign label`,
            },
        });
    }
    /**
     * Replace all labels for an entity
     * Replace all labels for a specific entity
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Entity ID
     * @param body New Labels
     * @returns void
     * @throws ApiError
     */
    public static putApiV1Labels(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
        body: labels_ReplaceLabelsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/{entityType}/{id}/labels',
            path: {
                'entityType': entityType,
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid request or missing/invalid parameters`,
                500: `Failed to replace labels`,
            },
        });
    }
    /**
     * Remove a label from an entity
     * Remove a label from a specific entity
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Entity ID
     * @param labelId Label ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Labels(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
        labelId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/{entityType}/{id}/labels/{labelId}',
            path: {
                'entityType': entityType,
                'id': id,
                'labelId': labelId,
            },
            errors: {
                400: `Invalid or missing parameters`,
                500: `Failed to remove label`,
            },
        });
    }
    /**
     * List label definitions
     * List label definitions for a specific entity type with pagination
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param limit Limit
     * @param offset Offset
     * @returns labels_LabelDefinitionResponse OK
     * @throws ApiError
     */
    public static getApiV1Labels1(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<labels_LabelDefinitionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/labels/{entityType}',
            path: {
                'entityType': entityType,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Failed to list label definitions`,
            },
        });
    }
    /**
     * Create a new label definition
     * Create a new label definition for a specific entity type
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param body Label Definition
     * @returns labels_LabelDefinitionResponse Created
     * @throws ApiError
     */
    public static postApiV1Labels1(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        body: labels_CreateLabelDefinitionRequest,
    ): CancelablePromise<labels_LabelDefinitionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/labels/{entityType}',
            path: {
                'entityType': entityType,
            },
            body: body,
            errors: {
                400: `Invalid request`,
                500: `Failed to create label definition`,
            },
        });
    }
    /**
     * Delete a label definition
     * Soft delete a label definition
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Label Definition ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Labels1(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/labels/{entityType}/{id}',
            path: {
                'entityType': entityType,
                'id': id,
            },
            errors: {
                400: `Invalid or missing parameters`,
                500: `Failed to delete label definition`,
            },
        });
    }
    /**
     * Get a label definition by ID
     * Get a label definition by ID
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Label Definition ID
     * @returns labels_LabelDefinitionResponse OK
     * @throws ApiError
     */
    public static getApiV1Labels2(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
    ): CancelablePromise<labels_LabelDefinitionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/labels/{entityType}/{id}',
            path: {
                'entityType': entityType,
                'id': id,
            },
            errors: {
                400: `Invalid or missing parameters`,
                404: `Label definition not found`,
                500: `Failed to get label definition`,
            },
        });
    }
    /**
     * Update a label definition
     * Update an existing label definition
     * @param entityType Entity Type (all, groups, children, employees, contacts, contracts)
     * @param id Label Definition ID
     * @param body Updated Label Definition
     * @returns labels_LabelDefinitionResponse OK
     * @throws ApiError
     */
    public static putApiV1Labels1(
        entityType: 'all' | 'groups' | 'children' | 'employees' | 'contacts' | 'contracts',
        id: string,
        body: labels_UpdateLabelDefinitionRequest,
    ): CancelablePromise<labels_LabelDefinitionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/labels/{entityType}/{id}',
            path: {
                'entityType': entityType,
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid request or missing/invalid parameters`,
                500: `Failed to update label definition`,
            },
        });
    }
    /**
     * List all label definitions
     * List all label definitions across all entity types with pagination
     * @param limit Limit
     * @param offset Offset
     * @returns labels_LabelDefinitionResponse OK
     * @throws ApiError
     */
    public static getApiV1LabelsAll(
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<Array<labels_LabelDefinitionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/labels/all',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Failed to list label definitions`,
            },
        });
    }
    /**
     * Bulk-resolve labels for many entities
     * Resolves the labels for a list of entity IDs of one entity type in a single request, returning a map of entity ID → labels. Replaces the per-entity N+1 (e.g. the Invoices tab fetching child labels one card at a time). entity_type is validated against an allowlist (use the singular "child" token for children); ids is capped at 500.
     * @param entityType Stored entity type token
     * @param ids Entity IDs (repeated or comma-separated), max 500
     * @returns labels_BulkEntityLabelsResponse OK
     * @throws ApiError
     */
    public static getApiV1LabelsByEntities(
        entityType: 'child' | 'groups' | 'employees' | 'contacts' | 'contracts',
        ids: Array<string>,
    ): CancelablePromise<labels_BulkEntityLabelsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/labels/by-entities',
            query: {
                'entity_type': entityType,
                'ids': ids,
            },
            errors: {
                400: `Invalid entity type, missing or too many ids`,
                403: `Organization ID not found in token`,
                500: `Failed to load labels`,
            },
        });
    }
}
